import {NgModule} from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from '@angular/material/core';
import {MomentDateAdapter} from '../MomentDateAdapterModule/moment-date-adapter';
import {MatDateFormats} from '@angular/material/core';

export const MOMENTDATEFORMATSCUSTOMADAPTER: MatDateFormats = {
  parse: {
    dateInput: 'YYYY MMM DD',
  },
  display: {
    dateInput: 'YYYY MMM DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]}
  ],
})
export class MomentDateAdapterModule {
}


@NgModule({
  imports: [MomentDateAdapterModule],
  providers: [{provide: MAT_DATE_FORMATS, useValue: MOMENTDATEFORMATSCUSTOMADAPTER}],
})
export class MatMomentDateModule {
}
